import HeaderBasket from './header-basket';
import helper from './helper';
import CountUp from 'countup.js';
import notification from './notification';

class Basket {
    constructor() {
        this.headerBasket = HeaderBasket;
        this.helper = helper;
        this.rowForUpdate = null;
        this.loading = false;
        let _this = this;

        $(document).on('change', '.shop-basket__counter', function () {
            if (this.loading) return;
            let data = _this.prepareData($(this), $(this).val());
            _this.sendAjax(data);
        });

        $(document).on('click', '.shop-basket__remove', function () {
            if (this.loading) return;
            let data = _this.prepareData($(this), 0);
            _this.sendAjax(data);
        });
    }

    prepareData(el, amount) {
        let productRow = el.closest('.shop-basket__row');
        let result = {
            orderItemId: productRow.data('orderItemId'),
            amount: amount,
        };

        // get data from all hidden fields
        productRow.find('input[type=hidden]').each((index, el) => {
            result[el.name] = el.value;
        });

        this.rowForUpdate = productRow;

        return result;
    }

    sendAjax(data) {
        let _this = this;
        $.ajax({
            url: '/cartChangeCount.json',
            type: 'POST',
            dataType: 'json',
            data: data,
            beforeSend() {
                _this.loading = true;
                if (data.amount === 0) {
                    if (
                        $('.shop-basket__body .shop-basket__row:visible')
                            .length == 1
                    ) {
                        $('.shop-basket').addClass('shop-basket--empty');
                    } else {
                        _this.rowForUpdate
                            .addClass('shop-basket__removing')
                            .slideUp(200);
                    }
                }
            },
            success(data) {
                if (data.result && data.result === 'fail') {
                    notification({ status: 'error', message: data.message });
                    return;
                } else if (data.result && data.result === 'success') {
                    setTimeout(() => {
                        _this.headerBasket.update(
                            data.totalQuantity || 0,
                            data.totalSum || 0
                        );
                        _this.complexUpdate(data);
                    }, 0);
                }
            },
            complete() {
                _this.loading = false;
            },
        });
    }

    checkBasketContent(data) {
        if (
            !data.hasOwnProperty('totalQuantity') ||
            !data.hasOwnProperty('totalSum')
        ) {
            $('.shop-basket').addClass('shop-basket--empty');
        }

        for (let key in data.orderItems) {
            let product = data.orderItems[key].product;
            if (product.availableForOrder !== true) {
                let productRow = $(
                    '.shop-basket__row[data-product-id=' + product.id + ']'
                );
                productRow.addClass('shop-basket__row--disabled');
                productRow.find('.counter__input').prop('disabled', true);
                productRow
                    .find('.shop-basket-text .shop-basket__v-middle')
                    .append(
                        `<div class="shop-passport__presense"><svg version="1.1" height="15" width="10" viewBox="0 0 14 20" aria-hidden="true" class="sst-svg-icon sst-svg-icon--ic-close "><path d="M14,4.41L12.59,3L7,8.59L1.41,3L0,4.41L5.59,10L0,15.59L1.41,17L7,11.41L12.59,17L14,15.59L8.41,10L14,4.41z"></path></svg> <span>Нет в наличии</span></div>`
                    );
            }
        }
    }

    complexUpdate(data) {
        this.checkBasketContent(data);
        this.updateRow(data);
        this.updateTotal(data);
    }

    updateRow(data) {
        let orderItem = findProductDataByValue(
            data,
            'OrderItemId',
            this.rowForUpdate.data('orderItemId')
        );
        if (orderItem == null) return;
        let calc =
            orderItem.OrderItemQuantity && orderItem.OrderItemQuantity > 1
                ? `${
                      orderItem.OrderItemQuantity
                  } x ${this.helper
                      .formatDecimals(orderItem.product.price)
                      .replace('.', ',')}`
                : '';
        let orderItemTotal =
            orderItem.OrderItemQuantity * orderItem.product.price;
        this.rowForUpdate.find('.shop-basket__calc').text(calc);
        this.rowForUpdate
            .find('.counter__input')
            .val(orderItem.OrderItemQuantity);
        this.rowForUpdate
            .find('.shop-basket__price')
            .html(
                this.helper
                    .formatDecimals(
                        isInt(orderItemTotal)
                            ? orderItemTotal
                            : orderItemTotal.toFixed(2)
                    )
                    .replace('.', ',')
            );
    }

    updateTotal(data) {
        let start = 0;
        let end = data.totalSum || 0;
        let animateNumber;
        try {
            start = parseFloat(
                $('.shop-basket-total__num')
                    .attr('data-total')
                    .replace(/\s/g, '')
            );
        } catch (e) {
            console.log(e);
        }
        animateNumber = new CountUp(
            $('.shop-basket-total__num')[0],
            start,
            end,
            isInt(end) ? 0 : 2,
            0.5,
            {
                separator: ' ',
                decimal: ',',
            }
        );
        animateNumber.start();

        $('.shop-basket-total__num').attr('data-total', end);
        $('.sst-basket-aside__info').html(
            `Всего ${
                data.totalQuantity
            } ${this.helper.declension(data.totalQuantity, [
                'товар',
                'товара',
                'товаров',
            ])} на сумму:`
        );
    }
}

function findProductDataByValue(o, key, value) {
    let result = null;
    if (typeof o !== 'object' || !o.hasOwnProperty('orderItems')) return result;
    for (let item in o.orderItems) {
        if (
            o.orderItems[item].hasOwnProperty(key) &&
            o.orderItems[item][key].toLowerCase() == value.toLowerCase()
        ) {
            return (result = o.orderItems[item]);
        }
    }
    return result;
}

function isInt(n) {
    return Number(n) === n && n % 1 === 0;
}

export default new Basket();
